import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconUpdate } from '../../../../../../assets/status-screen-icons/icon-update';
import { NavHeader, Page } from '../../../../../../components';
import FixedTwoButtons from '../../../../../../components/fixed-two-buttons';
import { ROUTES } from '../../../../../../routes/routes';
import { UpdateDialog } from '../../components/update-dialog';
import { useBluetoothContext } from '../../context';
import './index.scss';

const DeviceAddBluetoothUpdate: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('device-add');
  const { t: tc } = useTranslation('common');
  const [dialog, setDialog] = useState<boolean>(false);
  const { checkIfConnected, updateByWifi, updatePayload } = useBluetoothContext();

  useEffect(() => {
    checkIfConnected();
  }, []);

  const onUpdateSuccess = () => {
    setDialog(false);

    if (updatePayload.status) {
      navigate(ROUTES.DeviceUpdateBluetoothSuccess());
    }
  };

  const updateDevice = () => {
    updateByWifi();
    setDialog(true);
  };

  const cancel = () => navigate(-3);

  return (
    <Page className="device-add-update" header={<NavHeader />}>
      <div className="icon-container">
        <IconUpdate />
      </div>
      <div className="text-container">
        <p className="text-header">{t('addDeviceUpdate.header')}</p>
      </div>

      <FixedTwoButtons
        titlePrimary={t('addDeviceUpdate.update')}
        titleSecondary={tc('buttons.cancel')}
        handleClickPrimary={updateDevice}
        handleClickSecondary={cancel}
        separator={false}
      />
      <UpdateDialog show={dialog} onUpdateSuccess={onUpdateSuccess} />
    </Page>
  );
};

export default DeviceAddBluetoothUpdate;
